import { User } from 'src/app/shared/models/user.model';

export enum Provider {
  'JIBNIT' = 'JIBIT',
  'VADNAR' = 'VANDAR'
}

export class DipositTreasury {
  id: number;
  userId: number;
  amount: number;
  status!: 'PENDING' | 'CHECKED_BY_OPERATOR' | 'SUCCESSFUL' | 'ERROR';
  provider!: Provider;
  type: string;
  createdAt: string;
  succeed: boolean;
  userIban: string;
  userCreditCard: string;

  constructor(input: any = {}) {
    this.userId = input.user_id;
    this.id = input.id;
    this.provider = input.provider ?? Provider.JIBNIT;
    this.status = input.status;
    this.succeed = input.succeed;
    this.amount = Math.round(input.amount / 10);
    this.type = input.type;
    this.createdAt = input.created_at;
    this.userCreditCard = input.user_credit_card;
    this.userIban = input.user_iban;
  }
}
